var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditBlack({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.411,
    height: 17.412,
    viewBox: "0 0 17.411 17.412",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_49931",
    "data-name": "Group 49931",
    transform: "translate(-3056.25 -14583.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_49930",
    "data-name": "Group 49930",
    transform: "translate(3057 14584)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_44615",
    "data-name": "Group 44615"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_45152",
    "data-name": "Group 45152"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_89236",
    "data-name": "Path 89236",
    d: "M16.661,8.891v5.063a2.893,2.893,0,0,1-2.893,2.893H3.643A2.893,2.893,0,0,1,.75,13.954v-9.4A2.893,2.893,0,0,1,3.643,1.659h2.17",
    transform: "translate(-0.75 -0.936)",
    fill: "none",
    stroke: "#000c1f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89237",
    "data-name": "Path 89237",
    d: "M9.311,11.98,5.7,12.01V8.439L12.569,1.5a2.551,2.551,0,1,1,3.616,3.6Z",
    transform: "translate(-1.761 -0.75)",
    fill: "none",
    stroke: "#000c1f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditBlack);
export default __webpack_public_path__ + "static/media/edit_black.2d243080dacaeab954610db1efaa18c8.svg";
export { ForwardRef as ReactComponent };